import { CompensationReviewCampaignStatus } from "@prisma/client";
import { type AppContext } from "~/lib/context";
import {
  formatCompensationReviewCampaign,
  formatCompensationReviewEmployee,
  formatKnockTenant,
  formatKnockUser,
  selectCompensationReviewEmployeeForFormat,
  selectUserForFormat,
} from "~/lib/external/knock/format";
import { track } from "~/lib/external/segment/server/client";
import { type EventPayload } from "~/workers/handleEvent";

export const notifyOfSendBack = async (
  ctx: AppContext,
  params: EventPayload<"CompensationReview_RecommendationSentBack">
) => {
  const campaign = await ctx.prisma.compensationReviewCampaign.findUniqueOrThrow({
    where: { id: params.campaignId },
  });

  if (campaign.status !== CompensationReviewCampaignStatus.IN_PROGRESS) return;

  const recommendation = await ctx.prisma.compensationReviewRecommendation.findUniqueOrThrow({
    where: {
      id: params.recommendationId,
      campaignId: campaign.id,
    },
    select: {
      sentBackComment: true,
      reviewer: {
        select: {
          externalEmployee: {
            select: {
              userPermissions: {
                select: {
                  user: { select: selectUserForFormat },
                },
              },
            },
          },
        },
      },
      employee: { select: selectCompensationReviewEmployeeForFormat },
    },
  });

  if (!recommendation?.reviewer?.externalEmployee.userPermissions?.user) return;

  await track(ctx, "Compensation Review Recommendation Sent Back", {
    onBehalfOfUser: params.onBehalfOfUser,
    comment: recommendation.sentBackComment,
    company: formatKnockTenant(params.onBehalfOfUser.company),
    campaign: formatCompensationReviewCampaign(campaign),
    employee: formatCompensationReviewEmployee(recommendation.employee),
    user: formatKnockUser(params.onBehalfOfUser),
    reviewer: formatKnockUser(recommendation.reviewer.externalEmployee.userPermissions.user),
  });
};
